<template>
	<el-menu
		:default-active.sync="activeLink"
		:mode="mode"
		@select="goto"
		:collapse="isCollapse"
		:unique-opened="true"
		background-color="transparent"
		class="main-navigation-menu"
		:class="{'nav-collapsed':isCollapse}"
	>
		<div class="el-menu-item-group__title" style="padding-top: 4px;">
			<span>{{ $t("menu.menu") }}</span>
		</div>
		<el-menu-item index="/dashboard">
			<span class="mdi mdi-home"></span>
			<span slot="title">{{ $t("menu.dashboard") }}</span>
		</el-menu-item>
		<el-menu-item index="/consumen">
			<span class="mdi mdi-account-settings-variant"></span>
			<span slot="title">{{ $t("menu.consumen") }}</span>
		</el-menu-item>
		<el-submenu index="business" popper-class="main-navigation-submenu">
			<template slot="title">
				<span class="mdi mdi-file-chart"></span>
				<span>{{ $t("menu.business") }}</span>
			</template>
			<el-menu-item index="/business">
				<span slot="title">{{ $t("menu.business") }}</span>
			</el-menu-item>
			<el-menu-item index="/bussiness/market">
				<span slot="title">Market</span>
			</el-menu-item>
			<el-menu-item index="/bussiness/data">
				<span slot="title">Data</span>
			</el-menu-item>
			<el-menu-item index="/bussiness/report-transaction">
				<span slot="title">Report Transaction</span>
			</el-menu-item>
			<el-menu-item index="/bussiness/monitoring">
				<span slot="title">Monitoring</span>
			</el-menu-item>
		</el-submenu>
		<el-menu-item index="/billing" v-if="inRole('billing')">
			<span class="mdi mdi-cash-usd"></span>
			<span slot="title">{{ $t("menu.billing") }}</span>
		</el-menu-item>
		<!-- <el-menu-item index="/products" v-if="inRole('products')"> -->
		<el-menu-item index="/products">
			<span class="mdi mdi-basket"></span>
			<span slot="title">{{ $t("menu.products") }}</span>
		</el-menu-item>
		<el-menu-item index="/queue">
			<span class="mdi mdi-clock-in"></span>
			<span slot="title">{{ $t("menu.queue") }}</span>
		</el-menu-item>
		<!-- <el-menu-item index="/prefix">
			<span class="mdi mdi-cellphone-basic"></span>
			<span slot="title">{{ $t("menu.prefix") }}</span>
		</el-menu-item> -->
		<el-menu-item index="/template_messages">
			<span class="mdi mdi-message"></span>
			<span slot="title">{{ $t("menu.template") }}</span>
		</el-menu-item>
		<el-menu-item index="/wa_connect">
			<span class="mdi mdi-whatsapp"></span>
			<span slot="title">{{ $t("menu.wa_connect") }}</span>
		</el-menu-item>
		<!-- <el-menu-item index="/volta">
			<span class="mdi mdi-bike"></span>
			<span slot="title">{{ $t("menu.volta") }}</span>
		</el-menu-item> -->
		<el-menu-item index="/notification">
			<span class="mdi mdi-bell"></span>
			<span slot="title">{{ $t("menu.notification") }}</span>
		</el-menu-item>
		<el-submenu index="finance" popper-class="main-navigation-submenu">
			<template slot="title">
				<span class="mdi mdi-bank"></span>
				<span>Finance</span>
			</template>
			<!-- <el-menu-item index="/finance">
				<span slot="title">Finance</span>
			</el-menu-item> -->
			<el-menu-item index="/finance/config">
				<span slot="title">Config</span>
			</el-menu-item>
			<el-menu-item index="/finance/credit">
				<span slot="title">Credit</span>
			</el-menu-item>
			<el-menu-item index="/finance/tax-invoice">
				<span slot="title">Tax Invoice</span>
			</el-menu-item>
		</el-submenu>
		<!-- <el-menu-item index="/log">
			<span class="mdi mdi-clipboard"></span>
			<span slot="title">{{ $t("menu.log") }}</span>
		</el-menu-item> -->

		<!-- <el-menu-item index="/biller_switcher">
			<span class="mdi mdi-coin"></span>
			<span slot="title">{{ $t("menu.biller_switcher") }}</span>
		</el-menu-item> -->
		
		<el-menu-item index="/report">
			<span class="mdi mdi-file-document"></span>
			<span slot="title">{{ $t("menu.report") }}</span>
		</el-menu-item>
		<el-menu-item index="/management_admin">
			<span class="mdi mdi-account-edit"></span>
			<span slot="title">{{ $t("menu.management_admin") }}</span>
		</el-menu-item>
		<el-menu-item index="/log_admin">
			<span class="mdi mdi-file-account"></span>
			<span slot="title">{{ $t("menu.log_admin") }}</span>
		</el-menu-item>
	</el-menu>
</template>


<script>
import { detect } from 'detect-browser'
import config from '../config'
import store from '@/store'
const browser = detect()

export default {
	name: 'Nav',
	props: ['mode', 'isCollapse'],
	data() {
		return {
			isIe: true,
			isEdge: true,
			activeLink: null,
			config:config,
			allowedRole: store.getters.allowedRole
		}
	},
	methods: {
		goto(index, indexPath) {
			if(index.charAt(0) === '/') {
				this.$router.push(index)
				this.$emit('push-page', {page:index})
			}
			else {
				window.open(index, '_blank')
			}
		},
		setLink(path) {
			this.activeLink = path
		},
		inRole(val){
			if(_.indexOf(this.allowedRole, val) !== -1){
				return true
			} else{
				return false
			}
		}
	},
	created() {
		if(browser.name !== 'ie') this.isIe = false
		if(browser.name !== 'edge') this.isEdge = false

		this.setLink(this.$router.currentRoute.path)
		this.$router.afterEach((to, from) => {
			let routePath =
				this.$router &&
				this.$router.currentRoute &&
				this.$router.currentRoute.meta &&
				this.$router.currentRoute.meta.tags &&
				this.$router.currentRoute.meta.tags.length > 0
				? this.$router.currentRoute.meta.tags[0]
				: '';
			this.setLink(routePath);
			// console.log('afterEach', this.$router.currentRoute.meta.tags[0])
		})
		//console.log('this.$router.currentRoute.path', this.$router.currentRoute.path)
	},
	mounted() {
		//console.log('nav component mounted')
	}
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/_variables';

.el-menu {
	border: none;
}
.el-menu::before, .el-menu::after {
	display: none;
}
.el-submenu, .el-menu-item {
	.mdi {
		vertical-align: middle;
		margin-right: 5px;
		display: inline-block;
		width: 24px;
		text-align: center;
		font-size: 18px;
	}
}
</style>

<style lang="scss">
@import '../assets/scss/_variables';

.main-navigation-menu {
	transition: width .5s;

	&:not(.el-menu--collapse) {
		.el-submenu__title, .el-menu-item {
			height: 40px;
			line-height: 40px;
			background-color: transparent !important;
		}

		&:not(.el-menu--horizontal) {
			.el-menu-item, .el-submenu {
				position: relative;

				&::before {
					content: '';
					display: block;
					width: 0px;
					height: 1px;
					position: absolute;
					bottom: 10px;
					left: 30px;
					background: $text-color;
					z-index: 1;
					opacity: 0;
					transition: all .7s cubic-bezier(.55,0,.1,1);
				}
				&:hover {
					&::before {
						width: 100px;
						opacity: 1;
						//left: 50px;
						transform: translate(20px, 0);
					}
				}

				&.is-active {
					&::before {
						background: $text-color-accent;
					}
				}
			}
		}

		.el-submenu.is-opened {
			//background: /#edf1f6 !important;
			//background: rgba(223, 228, 234, 0.38) !important;
			position: relative;

			&::after {
				content: '';
				display: block;
				width: 2px;
				position: absolute;
				top: 40px;
				bottom: 10px;
				left: 31px;
				background: $text-color;
				z-index: 1;
			}

			&::before {
				display: none;
			}

			.el-menu-item, .el-submenu {
				&::before, &::after {
					display: none;
				}
			}
		}

		.el-menu-item-group__title {
			padding: 15px 0 0px 20px;
			color: transparentize($text-color, 0.65);
		}
	}

	.el-submenu__title, .el-menu-item:not(.is-active) {
		color: #ffffff;

		i {
			color: #ffffff;
		}
	}

	&.el-menu--collapse {
		.el-menu-item-group__title {
			padding: 15px 0 0px 0px;
			width: 100%;
			text-align: center;
		}

		.el-submenu__title:hover, .el-menu-item:hover {
			background-color: rgba(0, 0, 0, 0.05) !important;
		}
	}

	&.el-menu--horizontal {
		white-space: nowrap;
		/*width: fit-content;
		width: max-content;*/
		overflow: hidden;
		display: table;

		& > * {
			float: inherit !important;
			display: inline-block;
		}
	}

	&.nav-collapsed {
		.el-menu-item,.el-submenu__title {
			& > span {
				display: none;
			}
		}
	}
}

.main-navigation-submenu {
	.el-menu {
		background: #fff !important;

		.el-menu-item:not(.is-active) {
			color: $text-color;
		}
		.el-menu-item:hover {
			background-color: transparentize($background-color, 0.3) !important;
		}
	}
}
</style>
